import { useAuth } from "../../contexts/AuthContext";
import { useOrganization } from "../../contexts/OrganizationContext";
import type { WorkspaceScope } from "./types";
export function useToolScope(): WorkspaceScope | null {
  const { user } = useAuth();
  const { currentOrganization } = useOrganization();
  return user?.id && currentOrganization?.id
    ? { userId: user.id, organizationId: currentOrganization.id }
    : null;
}
